import chroma from "chroma-js";

export const WCAG_MIN_CONSTRAST_RATIO = 4.5;

export const colorAndOpacityToRGBA = (inputColor, opacity) => {
  if (!chroma.valid(inputColor)) return inputColor;

  const chromaColor = chroma(inputColor);

  return chromaColor.alpha(opacity).css();
};

export const colorIsAdaptedForForeground = (
  foregroundColor,
  backgroundColor = "white"
) => {
  if (!chroma.valid(foregroundColor)) return foregroundColor;

  return chroma.contrast(foregroundColor, backgroundColor) > WCAG_MIN_CONSTRAST_RATIO;
};
